import { Base64 } from "js-base64";
import React, { Fragment, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { AppContext } from "../../components/AppProvider";
import { AlertLayer } from "../../components/UI/Dialog";
import { InputDiv } from "../../components/UI/INPUT/InputDiv";
import { PostApi154, PostApi156 } from "../../modules/network/padoPost";
import { _O } from "../../modules/utils";
import { checkData } from "../../modules/utils/CheckLogic";
import { setCookies } from "../../modules/utils/cookie";
import { ContainerNew, SubMenu, openLayerFn } from "../Layout";
import { ExistIdLayer } from "../common/Modal/ExistIdLayer";
import useTitle from "../../modules/hooks/useTitle";

export default props => {
  const { phonecfg, cfg } = useContext(AppContext);
  useTitle(
    props.match.params.signUpChannel == "findPw"
      ? "로그인_비밀번호찾기"
      : "회원가입_정보입력"
  );
  const [gender, setGender] = useState();
  const [dupList, setDupList] = useState("");
  const [foreigner, setForeigner] = useState(0);

  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
    url: "",
  });

  const handleAlert = (title, msg, movePage) => {
    setDialog({
      title: title,
      msg: msg,
      url: movePage ? movePage : "",
    });

    openLayerFn($(".alert-layer"));
  };

  const bottom = (
    <div
      className="under-fix-btnarea"
      style={{ textAlign: "center", margin: "0px 15px", width: "auto" }}>
      <BtnNext
        innerWidth={window.innerWidth}
        onClick={() => {
          settingUserInfo();
        }}>
        확인
      </BtnNext>
    </div>
  );

  const bottomFind = (
    <div
      className="under-fix-btnarea"
      style={{ textAlign: "center", margin: "0px 15px", width: "auto" }}>
      <BtnNext
        innerWidth={window.innerWidth}
        onClick={() => {
          handleFindID();
        }}>
        확인
      </BtnNext>
    </div>
  );

  const handleFindID = popupYn => {
    if (checkInputEmpty()) {
      PostApi154(
        phonecfg,
        cfg,
        $("input[name=userName]").val().trim(),
        $("input[name=userPhone]").val().trim(),
        $("input[name=birth]").val().trim(),
        gender,
        "",
        "",
        foreigner
      )
        .then(res => {
          if (res.resultCode === "000") {
            if (res.joinInfo.length > 0) {
              setDupList(res.joinInfo);
              // openLayerFn($("#existLayer"));

              _O.Open(
                "/membership/findID/" +
                  Base64.encode(JSON.stringify(res.joinInfo))
              );
            } else {
              if (popupYn != "N") {
                handleAlert("", "가입된 정보가 없습니다.");
              } else {
                setCookies({
                  userName: $("input[name=userName]").val().trim(),
                  userBirth: $("input[name=birth]").val().trim(),
                  userPhone: $("input[name=userPhone]").val().trim(),
                  gender: gender,
                  timer: 180,
                  isForeigner: foreigner,
                });

                // _O.OpenMenu("/membership/searchHospital");
                const returnJson = {
                  userName: $("input[name=userName]").val().trim(),
                  userBirth: $("input[name=birth]").val().trim(),
                  userPhone: $("input[name=userPhone]").val().trim(),
                  Gender: gender,
                  isForeigner: foreigner,
                };
                const returnData = Base64.encode(JSON.stringify(returnJson));

                // _O.OpenMenu("/membership/addAccount/auto/"+encodeURIComponent(returnData.toString()));
                _O.OpenMenu(
                  "/membership/addAccount/auto/" + returnData.toString()
                );
              }
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  const bottomFindPw = (
    <div
      className="under-fix-btnarea"
      style={{ textAlign: "center", margin: "0px 15px", width: "auto" }}>
      <BtnNext
        innerWidth={window.innerWidth}
        onClick={() => {
          goFindPW();
        }}>
        인증번호 요청
      </BtnNext>
    </div>
  );

  const requestCertiNo = () => {
    PostApi156(
      phonecfg,
      cfg,
      $("input[name=userId]").val().trim(),
      $("input[name=userName]").val().trim(),
      $("input[name=birth]").val().trim(),
      $("input[name=userPhone]").val().trim(),
      gender
    )
      .then(res => {
        if (res.result === 0) {
          handleAlert("", "가입된 정보가 없습니다.");
        } else {
          setCookies({
            userId: $("input[name=userId]").val().trim(),
            userName: $("input[name=userName]").val().trim(),
            userBirth: $("input[name=birth]").val().trim(),
            userPhone: $("input[name=userPhone]").val().trim(),
            gender: gender,
            timer: 180,
          });
          _O.Open("/membership/checkCertiNo");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const goFindPW = () => {
    if (checkInputEmpty()) {
      requestCertiNo();
    }
  };

  const checkInputEmpty = () => {
    //ID, password, passwordCheck
    if (props.match.params.signUpChannel == "findPw") {
      if ($("input[name=userId]").val() == "") {
        errMsgPlay("id", "아이디를 입력하세요.");
        return false;
      }
    }

    if ($("input[name=userName]").val() == "") {
      errMsgPlay("name", "이름을 입력하세요.");
      return false;
    }
    if ($("input[name=birth]").val() == "") {
      errMsgPlay("birth", "생년월일 8자리를 입력하세요.");
      return false;
    } else if ($("input[name=birth]").val().length < 8) {
      errMsgPlay("birth", "생년월일 8자리를 입력하세요.");
      return false;
    } else if (!checkData("birth", $("input[name=birth]").val())) {
      errMsgPlay("birth", "잘못된 생년월일 입니다.");
      return false;
    }

    if ($("input[name=userPhone]").val() == "") {
      errMsgPlay("phone", "휴대폰 번호를 입력하세요.");
      return false;
    } else if ($("input[name=userPhone]").val().length < 10) {
      errMsgPlay("phone", "휴대폰 번호를 입력하세요.");
      return false;
    }

    if (!gender) {
      handleAlert("", "성별을 선택하세요.");
      return false;
    }

    return true;
  };

  const checkAccount = () => {
    PostApi154;
  };

  const settingUserInfo = () => {
    if (checkInputEmpty()) {
      // 가입여부 확인
      // 중복된 정보 있을시 중복리스트 조회 후 가입유도
      if (props.match.params.signUpChannel === "find") {
        handleFindID("Y");
      } else {
        handleFindID("N");
      }
    }
  };

  const openWebSocket = () => {
    // socketManager(SocketCommand.GET_PHONE_INFO, undefined);
    // if (phonecfg.phoneOS == "IOS") {
    //   socketManager(SocketCommand.GET_GPS_INFO, undefined);
    // }
  };

  useEffect(() => {
    if (phonecfg.phoneToken == "123" || phonecfg.version == "2.0.0") {
      openWebSocket();
    }
  }, [phonecfg]);

  const errMsgPlay = (target, errText) => {
    resetErrMsgState();
    resetErrMsgText();

    if (target == "id") {
      $("#errMsgId").text(errText);
      setErrMsgId(true);
    }

    if (target == "name") {
      $("#errMsgName").text(errText);
      setErrMsgName(true);
    }
    if (target == "birth") {
      $("#errMsgBirth").text(errText);
      setErrMsgBirth(true);
    }
    if (target == "phone") {
      $("#errMsgPhone").text(errText);
      setErrMsgPhone(true);
    }
  };

  const resetErrMsgState = () => {
    setErrMsgId(false);
    setErrMsgName(false);
    setErrMsgBirth(false);
    setErrMsgGender(false);
    setErrMsgPhone(false);
  };

  const resetErrMsgText = () => {
    $("#errMsgId").text("");
    $("#errMsgName").text("");
    $("#errMsgBirth").text("");
    $("#errMsgPhone").text("");
  };

  const normStyle = {
    marginBottom: "8px",
    backgroundColor: "#f7f7f7",
    borderRadius: "8px",
  };
  const errStyle = {
    marginBottom: "8px",
    backgroundColor: "#f7f7f7",
    borderRadius: "8px",
    border: "1px solid red",
    color: "red",
  };
  const [errMsgId, setErrMsgId] = useState(false);
  const [errMsgName, setErrMsgName] = useState(false);
  const [errMsgBirth, setErrMsgBirth] = useState(false);
  const [errMsgGender, setErrMsgGender] = useState(false);
  const [errMsgPhone, setErrMsgPhone] = useState(false);
  return (
    <Fragment>
      <ContainerNew
        Title={"본인인증"}
        dark={"dark"}
        leftMenu={SubMenu}
        rightMenu={-1}
        isMain={true}>
        <Contents>
          {props.match.params.signUpChannel != "findPw" &&
            props.match.params.signUpChannel != "find" && <SubTitleCpnt />}
          {props.match.params.signUpChannel == "find" && <SubTitleFind />}
          {props.match.params.signUpChannel == "findPw" && <SubTitleFindPw />}

          {/* input area */}
          <div>
            {props.match.params.signUpChannel == "findPw" && (
              <Fragment>
                <DivTitle>아이디</DivTitle>
                <InputDiv
                  type="text"
                  name="userId"
                  placeholder="아이디"
                  style={!errMsgId ? normStyle : errStyle}
                  defaultValue={props.match.params.userId}
                />
                <div
                  id="errMsgId"
                  style={{
                    marginBottom: "16px",
                    marginLeft: "8px",
                    color: "red",
                  }}
                />
              </Fragment>
            )}

            <DivTitle>이름</DivTitle>
            <InputDiv
              type="text"
              name="userName"
              placeholder="이름"
              maxLength={20}
              style={!errMsgName ? normStyle : errStyle}
            />
            <div
              id="errMsgName"
              style={{ marginBottom: "16px", marginLeft: "8px", color: "red" }}
            />

            <div>
              <div>
                <DivTitle>생년월일</DivTitle>
                <InputDiv
                  type="number"
                  pattern="\d*"
                  name="birth"
                  placeholder="예) 19901201"
                  maxLength={8}
                  onChange={true}
                  style={!errMsgBirth ? normStyle : errStyle}
                />
              </div>
            </div>
            <div
              id="errMsgBirth"
              style={{ marginBottom: "16px", marginLeft: "8px", color: "red" }}
            />

            <div style={{ display: "flex", marginBottom: "16px" }}>
              <div style={{ width: "47%" }}>
                <DivTitle>성별</DivTitle>
                <UserInfoGender setGender={setGender} />
              </div>
              <div style={{ marginLeft: "auto", width: "47%" }}>
                <DivTitle>내/외국인</DivTitle>
                <UserInfoNation setEvent={setForeigner} />
              </div>
            </div>

            <DivTitle>휴대폰번호</DivTitle>
            <InputDiv
              type="number"
              pattern="\d*"
              name="userPhone"
              placeholder="예) 01012345678"
              maxLength={11}
              onChange={true}
              style={!errMsgPhone ? normStyle : errStyle}
            />
            <div
              id="errMsgPhone"
              style={{ marginBottom: "16px", marginLeft: "8px", color: "red" }}
            />
          </div>

          {props.match.params.signUpChannel == "findPw" ? (
            <BottomFindPw goFindPW={goFindPW} />
          ) : (
            <Bottom settingUserInfo={settingUserInfo} />
          )}
        </Contents>
      </ContainerNew>
      <AlertLayer title={dialog.title} msg={dialog.msg} url={dialog.url} />
      <ExistIdLayer dupList={dupList} />
    </Fragment>
  );
};

const Bottom = ({ settingUserInfo }) => {
  return (
    <div
      className="under-fix-btnarea"
      style={{ textAlign: "center", margin: "0px 15px", width: "auto" }}
    >
      <BtnNext
        innerWidth={window.innerWidth}
        onClick={() => {
          settingUserInfo();
        }}
      >
        확인
      </BtnNext>
    </div>
  );
};

const BottomFindPw = ({ goFindPW }) => {
  return (
    <div
      className="under-fix-btnarea"
      style={{ textAlign: "center", margin: "0px 15px", width: "auto" }}
    >
      <BtnNext
        innerWidth={window.innerWidth}
        onClick={() => {
          goFindPW();
        }}
      >
        인증번호 요청
      </BtnNext>
    </div>
  );
};

const Contents = ({ children }) => {
  return (
    <div className="contents">
      <div className="sub-contents">{children}</div>
    </div>
  );
};

const UserInfoGender = (props) => {
  const { setGender } = props;

  return (
    <div>
      <div className="select-custom-box">
        <a className="btn-select" style={{ backgroundColor: "#f7f7f7" }}>
          성별
        </a>
        <ul style={{ backgroundColor: "#f7f7f7" }}>
          <li onClick={() => setGender("1")}>
            <a>남자</a>
          </li>
          <li onClick={() => setGender("0")}>
            <a>여자</a>
          </li>
        </ul>
      </div>
    </div>
  );
};

const UserInfoNation = (props) => {
  const { setEvent } = props;

  return (
    <div>
      <div className="select-custom-box">
        <a className="btn-select" style={{ backgroundColor: "#f7f7f7" }}>
          내국인
        </a>
        <ul style={{ backgroundColor: "#f7f7f7" }}>
          <li onClick={() => setEvent("0")}>
            <a>내국인</a>
          </li>
          <li onClick={() => setEvent("1")}>
            <a>외국인</a>
          </li>
        </ul>
      </div>
    </div>
  );
};

const SubTitleCpnt = () => {
  return (
    <Fragment>
      <SubTitle>회원정보</SubTitle>
      <div style={{ padding: "8px 0px" }}>
        <p>의료기관에 등록된 정보를 입력하세요</p>
        <p>
          <font style={{ color: "red", fontSize: "16px", fontWeight: "700" }}>
            정보가 동일하면 &nbsp;
          </font>
          <font style={{ fontSize: "16px", fontWeight: "700" }}>진료이력 &nbsp;</font>
          등의 사용이 쉬워집니다.
        </p>
      </div>
    </Fragment>
  );
};

const SubTitleFind = () => {
  return (
    <Fragment>
      <SubTitle>아이디 찾기</SubTitle>
      <div style={{ padding: "8px 0px" }}>
        <p>병원 등록 정보 조회합니다.</p>
        <p>
          <font style={{ color: "red", fontSize: "16px", fontWeight: "700" }}>
            병원에서 사용하는 이름, 생일, 휴대폰 번호
          </font>
          를 입력 하세요
        </p>
      </div>
    </Fragment>
  );
};

const SubTitleFindPw = () => {
  return (
    <Fragment>
      <SubTitle>비밀번호 찾기</SubTitle>
      <div style={{ padding: "8px 0px" }}>
        {/* <p>병원 등록 정보 조회합니다.</p> */}
        <p>
          <font style={{ color: "red", fontSize: "16px", fontWeight: "700" }}>
            병원에서 사용하는 이름, 생일, 휴대폰 번호
          </font>
          를 입력 하세요
        </p>
      </div>
    </Fragment>
  );
};

const SubTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin-top: 37px;
`;

const BtnNext = styled.div`
  bottom: 86px;
  width: ${(props) => window.innerWidth - 30}px;
  height: 50px;
  line-height: 50px;
  background: #000000 0% 0% no-repeat padding-box;
  color: #fff;
  border-radius: 4px;
  opacity: 1;
  font-size: 17px;
`;

const DivTitle = styled.div`
  padding-left: 4px;
  font-weight: 700;
  margin-bottom: 4px;
`

const DivErrTitle = styled.div`
  padding-left: 7px;
  font-weight: 700;
  margin-bottom: 4px;
`